import styled from '@emotion/styled/macro';
import { Variables, MetricsValue, TypographyStyles } from '@enter/core';

export const HeaderContainer = styled.div`
    margin-top: ${MetricsValue.RegularMl}px;
`;

export const TitleRow = styled.div`
    margin-bottom: ${MetricsValue.RegularMs}px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const TitleGroup = styled.div`
    display: flex;
    align-items: center;
    gap: ${MetricsValue.RegularMd}px;
`;

export const Title = styled.h3`
    margin: 0;
    font-family: ${TypographyStyles.H3.fontFamily};
    font-size: ${TypographyStyles.H3.fontSize}px;
    font-weight: ${Variables.FontWeight.medium};
    line-height: ${TypographyStyles.H3.lineHeight === 'AUTO' ? 'normal' : TypographyStyles.H3.lineHeight};
    letter-spacing: ${TypographyStyles.H3.letterSpacing === '0%' ? '0' : TypographyStyles.H3.letterSpacing};
    color: ${Variables.Colors.p500};
`;

export const ActionsGroup = styled.div`
    display: flex;
    gap: ${MetricsValue.RegularSm}px;
`;

export const ActionButton = styled.button`
    background: transparent;
    border: none;
    border-radius: ${Variables.Rounded.small}px;
    padding: ${MetricsValue.RegularSm}px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const BadgesContainer = styled.div`
    margin-bottom: ${MetricsValue.RegularMl}px;
    display: flex;
    gap: ${MetricsValue.RegularMs}px;
    flex-wrap: wrap;
    align-items: center;
`;

export const BadgeContent = styled.span`
    display: inline-flex;
    align-items: center;
    gap: ${MetricsValue.RegularXs}px;
`;

